import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { attrs: { flat: "" } },
    [
      _c(
        VCardTitle,
        { staticClass: "pa-0 ma-0" },
        [
          _c(VCheckbox, {
            attrs: { color: "secondary", label: _vm.value.titulo },
            model: {
              value: _vm.value.opcao,
              callback: function ($$v) {
                _vm.$set(_vm.value, "opcao", $$v)
              },
              expression: "value.opcao",
            },
          }),
          _vm.value.opcao
            ? _c(VTextField, {
                staticClass: "ml-6 caption",
                attrs: { label: "Insira um termo", "prepend-icon": "search" },
                model: {
                  value: _vm.value.outros,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.value,
                      "outros",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "value.outros",
                },
              })
            : _vm._e(),
          _vm._t("children"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }